import React from 'react';
import { number, string, object } from 'prop-types';
const Weekday = (props) => {
    const { weekday, className, localeUtils, locale } = props;
    const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
    return (React.createElement("div", { className: className, title: weekdayName }, weekdayName.slice(0, 3)));
};
Weekday.propTypes = {
    weekday: number.isRequired,
    className: string,
    locale: string.isRequired,
    localeUtils: object.isRequired,
};
Weekday.defaultProps = {
    className: null,
};
export default Weekday;
